export default __webpack_public_path__ + "static/media/accounts.0a2555b9.svg";